<template>
	<div>
		<div class="d-flex justify-content-between">
			<h1 class="page-header ts-uppercase ts-font-bold">{{ $t('paymentTracking.pageTitle') }}</h1>
			<ts-breadcrumb :items="[
				{ text: $t('toHomePage'), href: '/' },
				{
					text: $t('paymentTracking.pageTitle'),
					active: true
				},
				{ text: $t('show'), active: true }
			]" />
		</div>
		<ts-card>
			<ts-card-wrapper>
				<div class="row">
					<div class="col-md-12">
						<form class="form-horizontal">
							<fieldset>
								<legend>{{ $t('invoice.invoiceInfo') }}</legend>
								<div class="row">
									<div class="col-md-4">
										<div class="row">
											<label class="col-md-4 col-form-label">{{ $t('invoice.invoiceDate') }}
												:</label>
											<div class="col-md-8">
												<input type="text" class="form-control-plaintext text-red ts-font-bold"
													:value="showData.inv_date" readonly />
											</div>
										</div>
										<div class="row">
											<label class="col-md-4 col-form-label">{{ $t('invoice.invoiceNumber') }}
												:</label>
											<div class="col-md-8">
												<input type="text" class="form-control-plaintext text-red ts-font-bold"
													:value="showData.inv_number" readonly />
											</div>
										</div>
										<div class="row">
											<label class="col-md-4 col-form-label">{{ $t('invoice.amount') }} :</label>
											<div class="col-md-8">
												<input type="text" class="form-control-plaintext" :value="showData.total_amount" readonly />
											</div>
										</div>
										<div class="row">
											<label class="col-md-4 col-form-label">{{ $t('invoice.paidAmount') }}
												:</label>
											<div class="col-md-8">
												<input type="text" class="form-control-plaintext" :value="showData.amount_paid" readonly />
											</div>
										</div>
										<div class="row">
											<label class="col-md-4 col-form-label">{{ $t('invoice.dueAmount') }}
												:</label>
											<div class="col-md-8">
												<input type="text" class="form-control-plaintext" :value="showData.amount_due" readonly />
											</div>
										</div>
										<div class="row">
											<label class="col-md-4 col-form-label">{{ $t('invoice.cashier') }} :</label>
											<div class="col-md-8">
												<input type="text" class="form-control-plaintext" :value="showData.user.employee.name_en"
													readonly />
											</div>
										</div>
									</div>
									<div class="col-md-4">
										<div class="row">
											<label class="col-md-4 col-form-label">{{ $t('invoice.studentName') }}
												:</label>
											<div class="col-md-8">
												<input type="text" class="form-control-plaintext text-primary"
													:value="showData.student.full_name_en" readonly />
											</div>
										</div>
										<div class="row">
											<label class="col-md-4 col-form-label">{{ $t('invoice.studentId') }}
												:</label>
											<div class="col-md-8">
												<input type="text" class="form-control-plaintext text-primary"
													:value="showData.student.card_number" readonly />
											</div>
										</div>
										<div class="row">
											<label class="col-md-4 col-form-label">{{ $t('invoice.sex') }} :</label>
											<div class="col-md-8">
												<input type="text" class="form-control-plaintext text-primary" :value="showData.student.gender"
													readonly />
											</div>
										</div>
										<div class="row">
											<label class="col-md-4 col-form-label">{{ $t('invoice.phoneNumber') }}
												:</label>
											<div class="col-md-8">
												<input type="text" class="form-control-plaintext text-primary" :value="showData.student.phone"
													readonly />
											</div>
										</div>
									</div>
									<div class="col-md-4">
										<div class="row">
											<label class="col-md-4 col-form-label">{{ $t('invoice.subProgram') }}
												:</label>
											<div class="col-md-8">
												<input type="text" class="form-control-plaintext"
													:value="showData.sub_program.acps_name_foreign" readonly />
											</div>
										</div>
										<div class="row">
											<label class="col-md-4 col-form-label">{{ $t('invoice.grade') }} :</label>
											<div class="col-md-8">
												<input type="text" class="form-control-plaintext text-primary"
													:value="showData.grade.grade_name_foreign" readonly />
											</div>
										</div>
										<div class="row">
											<label class="col-md-4 col-form-label">{{ $t('invoice.className') }}
												:</label>
											<div class="col-md-8">
												<input type="text" class="form-control-plaintext text-info"
													:value="showData.academic_class.class_name" readonly />
											</div>
										</div>
										<div class="row">
											<label class="col-md-4 col-form-label">{{ $t('invoice.studyTime') }}
												:</label>
											<div class="col-md-8">
												<input type="text" class="form-control-plaintext text-warning" :value="showData.study_time"
													readonly />
											</div>
										</div>
									</div>
								</div>
							</fieldset>
						</form>
					</div>
				</div>
				<div class="row mt-3">
					<div class="col-md-12">
						<panel :title="$t('invoice.detailInfo')">
							<table id="table-details">
								<thead>
									<tr>
										<th class="ts-whitespace-no-wrap" style="width:200px">
											{{ $t('invoice.feeType') }}
										</th>
										<th class="ts-whitespace-no-wrap" style="width:200px">
											{{ $t('invoice.feeName') }}
										</th>
										<th class="ts-whitespace-no-wrap" style="width: 190px;">
											{{ $t('invoice.description') }}
										</th>
										<th class="ts-whitespace-no-wrap" style="width: 140px;">
											{{ $t('invoice.dateFrom') }}
										</th>
										<th class="ts-whitespace-no-wrap" style="width: 140px;">
											{{ $t('invoice.dateTo') }}
										</th>
										<th class="ts-whitespace-no-wrap text-center" style="width: 70px;">
											{{ $t('invoice.qty') }}
										</th>
										<th class="ts-whitespace-no-wrap text-center" style="width: 99px;">
											{{ $t('invoice.fee') }}
										</th>
										<th class="ts-whitespace-no-wrap" style="width: 93px;">
											{{ $t('invoice.discountType') }}
										</th>
										<th class="ts-whitespace-no-wrap text-center" style="width: 94px;">
											{{ $t('invoice.discount') }}
										</th>
										<th class="ts-whitespace-no-wrap text-center" style="width: 81px;">
											{{ $t('invoice.vat') }}(%)
										</th>
										<th class="ts-whitespace-no-wrap text-right" style="width: 90px;">
											{{ $t('invoice.amount') }}
										</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(detail, index) in showData.invoice_detail" :key="index">
										<td>{{ detail.fee_type.fee_type_name }}</td>
										<td>{{ detail.fee_setup.fee_name_en }}</td>
										<td>{{ detail.fee_description }}</td>
										<td>{{ detail.fee_start_date }}</td>
										<td>{{ detail.fee_end_date }}</td>
										<td class="text-center">{{ detail.quantity }}</td>
										<td class="text-center">
											{{ currency(detail.fee_amount) }}
										</td>
										<td class="text-center">{{ detail.discount_type }}</td>
										<td class="text-center">{{ detail.discount_rate }}</td>
										<td class="text-center">{{ detail.vat_rate }}</td>
										<td class="text-right">
											{{ currency(detail.total_amount) }}
										</td>
									</tr>
								</tbody>
							</table>
						</panel>
						<div class="text-right">
							<ts-button @click.prevent="$router.push({ name: 'payment-tracking' })">{{
								$t('back')
							}}</ts-button>
						</div>
					</div>
				</div>
			</ts-card-wrapper>
		</ts-card>
	</div>
</template>

<script>
import { mapState } from 'vuex'
export default {
	name: 'trackInvoice',
	data() {
		return {}
	},
	computed: {
		...mapState('invoice', ['showData']),
		currency: vm => value => {
			return new Intl.NumberFormat('en-US', {
				style: 'currency',
				currency: 'USD'
			}).format(value)
		}
	},
}
</script>

<style lang="css" scoped>
#table-details {
	width: 100%;
}

#table-details>thead>tr>th {
	padding: 5px 4px;
	background: #f2f3f4;
}

#table-details>tbody>tr>td {
	padding: 5px 4px;
	border: none !important;
	font-size: 12px !important;
	border-bottom: 1px solid #ececec !important;
}
</style>
